/**
 * Display grouping for a section's element lengths.
 *
 * Nothing here plans anything. The backend decides how a section is split
 * (`planning.plan_run`); this only collapses `[1000, 1000, 1000, 500]` into
 * "3 × 1.000 mm + 500 mm", because eighteen identical numbers in a row are
 * read as noise and the same list as "17 × 1.000 mm + 500 mm" is read as a
 * count. Consecutive equal lengths only — the order the backend produced is
 * never changed.
 */

export interface ElementGroup {
  lengthMm: number;
  count: number;
}

export function groupElements(elements: readonly number[]): ElementGroup[] {
  const groups: ElementGroup[] = [];

  for (const lengthMm of elements) {
    const last = groups.at(-1);
    if (last && last.lengthMm === lengthMm) {
      last.count += 1;
    } else {
      groups.push({ lengthMm, count: 1 });
    }
  }

  return groups;
}
